const ChevronThinLeftWhite = () => (
    <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 1 1 7l6 6" stroke="#fff" strokeWidth="1.2" strokeLinecap="square" />
    </svg>
)

export default ChevronThinLeftWhite;
